export const LOADING_CONF_SMART = "LOADING_CONF_SMART";
export const SAVE_LOADING_CONF_SMART = "SAVE_LOADING_CONF_SMART";
export const GET_CONF_SMART = "GET_CONF_SMART";
export const GET_CONF_SMART_EMPLEADOS = "GET_CONF_SMART_EMPLEADOS";
export const FORM_FAIL = "FORM_FAIL";
export const CONF_SMART_FAIL = "CONF_SMART_FAIL";
export const LOADING_CONF_SMART_BY_ID = "LOADING_CONF_SMART_BY_ID";
export const GET_CONF_SMART_BY_ID = "GET_CONF_SMART_BY_ID";

